import React from "react";
import { useLanguage } from "../i18n/LanguageContext";

const ProactiveMessage = () => {
  const { t } = useLanguage();

  return (
    <div className="bg-gray-50 py-12 md:py-24">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Image Side */}
          <div className="order-2 md:order-1">
            <img
              src="/images/yoel_escritorio.jpg"
              alt={t.proactive.imageAlt}
              className="rounded-lg shadow-lg w-full h-[400px] object-cover object-[25%_top]"
            />
          </div>

          {/* Text Side */}
          <div className="order-1 md:order-2">
            <h2 className="text-2xl md:text-4xl font-light leading-relaxed text-gray-800">
              {t.proactive.message}
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProactiveMessage;
